
<div class="content">
  <div
    class="card"
    *ngIf="
      enabledRouteContains('/ebu/engines/sales-realization') ||
      enabledRouteContains('/ebu/parts/ebu')
    "
  >
    <div class="header">
      <p>
        <b>EBU</b>
      </p>
      <div class="img-container">
        <img class="category-img" src="/assets/images/EBU.png" />
      </div>
      <div class="hide">
        <div class="btn-container">
          <div>
            <button
              mat-flat-button
              class="{{ showEngines ? 'btn-color' : 'btn' }}"
              (click)="expandEngines()"
              *ngIf="enabledRouteContains('/ebu/engines/sales-realization')"
            >
              Engines
            </button>
            <div *ngIf="showEngines">
              <button
                *ngIf="enabledRouteContains('/ebu/engines/sales-realization')"
                mat-flat-button
                class="{{
                  activeItem == 'ebuSr' ? 'exbtn-color' : 'exbtn'
                }} font-weight"
                (click)="setActiveItem('ebuSr')"
              >
                Sales Realization
              </button>

              <div *ngIf="activeItem == 'ebuSr'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains('/ebu/engines/sales-realization/All')
                  "
                  routerLink="ebu/engines/sales-realization/All"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains('/ebu/engines/sales-realization/industrial')
                  "
                  routerLink="ebu/engines/sales-realization/industrial"
                >
                  Industrial
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains('/ebu/engines/sales-realization/onHighway')
                  "
                  routerLink="ebu/engines/sales-realization/onHighway"
                >
                  On Highway
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains('/ebu/engines/sales-realization/powerGen')
                  "
                  routerLink="/ebu/engines/sales-realization/powerGen"
                >
                  Power Gen
                </button>
              </div>

              <button mat-flat-button disabled="true" class="exbtn">
                Margin Realization
              </button>
              <button mat-flat-button disabled="true" class="exbtn">
                Profitability
              </button>
            </div>
            <button
              mat-flat-button
              class="{{ showParts ? 'btn-color' : 'btn' }}"
              (click)="expandParts()"
              *ngIf="enabledRouteContains('/ebu/parts/ebu')"
            >
              Parts
            </button>
            <div *ngIf="showParts">
              <button
                *ngIf="enabledRouteContains('/ebu/parts/ebu')"
                mat-flat-button
                class="{{ showSalesParts ? 'exbtn-color' : 'exbtn' }}  "
                routerLink="ebu/parts/ebu"
              >
                Sales/Margin Realization
              </button>

              <!-- submenu -->
              <div *ngIf="showSalesParts">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="enabledRouteContains('/ebu/parts/ebu')"
                  routerLink="ebu/parts/ebu"
                >
                  EBU
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="enabledRouteContains('/ebu/parts/psbu')"
                  routerLink="ebu/parts/psbu"
                >
                  PSBU
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="enabledRouteContains('/ebu/parts/ctt')"
                  routerLink="ebu/parts/ctt"
                >
                  CTT
                </button>
              </div>
              <!-- end of sub menu -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="card"
    *ngIf="
      enabledRouteContains('/distribution/cssna/powerGen/powerGen') ||
      enabledRouteContains('/distribution/cssna/engines/industrial') ||
      enabledRouteContains('/distribution/cssna/engines/on-highway') ||
      enabledRouteContains('/distribution/international/parts') ||
      enabledRouteContains('/distribution/international/parts/AME') ||
      enabledRouteContains('/distribution/international/parts/Arabia-JV') ||
      enabledRouteContains('/distribution/international/parts/Asia-Pacific') ||
      enabledRouteContains('/distribution/international/parts/East-Asia') ||
      enabledRouteContains(
        '/distribution/international/parts/Greater-Europe'
      ) ||
      enabledRouteContains('/distribution/international/parts/India') ||
      enabledRouteContains('/distribution/international/parts/Latin-America')
    "
  >
    <div class="header">
      <p>
        <b>Distribution</b>
      </p>
      <div class="img-container">
        <img class="category-img" src="/assets/images/Artboard 4.png" />
      </div>
      <div class="hide">
        <div class="btn-container">
          <div>
            <button
              mat-flat-button
              class="{{ showCssna ? 'btn-color' : 'btn' }}"
              (click)="expandCssna()"
              *ngIf="
                enabledRouteContains('/distribution/cssna/powerGen/powerGen') ||
                enabledRouteContains('/distribution/cssna/engines/industrial') ||
                enabledRouteContains('/distribution/cssna/engines/on-highway')
              "
            >
              CSSNA
            </button>
            <div *ngIf="showCssna">
              <button
                mat-flat-button
                class="{{ powerGen ? 'exbtn-color' : 'exbtn' }} font-weight"
                (click)="expandPowerGen()"
              >
                Power Gen
              </button>
              <div *ngIf="powerGen">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/powerGen/powerGen'
                    )
                  "
                  routerLink="distribution/cssna/powerGen/powerGen"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/powerGen/powerGen'
                    )
                  "
                  routerLink="distribution/cssna/powerGen/powerGen"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/powerGen/powerGen'
                    )
                  "
                  routerLink="distribution/cssna/powerGen/powerGen"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/powerGen/powerGen'
                    )
                  "
                  routerLink="distribution/cssna/powerGen/powerGen"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>

              <!-- CSSNA industrial -->

              <button
                mat-flat-button
                class="{{ industrial ? 'exbtn-color' : 'exbtn' }} font-weight"
                (click)="expandIndustrial()"
              >
                Industrial
              </button>
              <div *ngIf="industrial">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/industrial'
                    )
                  "
                  routerLink="distribution/cssna/engines/industrial"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/industrial'
                    )
                  "
                  routerLink="distribution/cssna/engines/industrial"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/industrial'
                    )
                  "
                  routerLink="distribution/cssna/engines/industrial"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/industrial'
                    )
                  "
                  routerLink="distribution/cssna/engines/industrial"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
              <!-- end of CSSNA industrial -->

              <!-- Start CSSNA on Highway -->

              <button
                mat-flat-button
                class="exbtn"
                class="{{ onHighway ? 'exbtn-color' : 'exbtn' }} font-weight"
                (click)="expandonHighway()"
              >
                On Highway
              </button>
              <div *ngIf="onHighway">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/on-highway'
                    )
                  "
                  routerLink="distribution/cssna/engines/on-highway"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/on-highway'
                    )
                  "
                  routerLink="distribution/cssna/engines/on-highway"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/on-highway'
                    )
                  "
                  routerLink="distribution/cssna/engines/on-highway"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/cssna/engines/on-highway'
                    )
                  "
                  routerLink="distribution/cssna/engines/on-highway"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
              <!-- end CSSNA on Highway -->
              <button mat-flat-button class="exbtn font-weight" *ngIf="enabledRouteContains('/customerLevel')"
                routerLink="customerLevel">
                Customer Level
              </button>
            </div>
            <!-- end of CSSNA -->

            <!-- International Start -->
            <button
              mat-flat-button
              class="{{ showInter ? 'btn-color' : 'btn' }}"
              (click)="expandInter()"
              *ngIf="
                enabledRouteContains('/distribution/international/parts') ||
                enabledRouteContains('/distribution/international/parts/AME') ||
                enabledRouteContains(
                  '/distribution/international/parts/Arabia-JV'
                ) ||
                enabledRouteContains(
                  '/distribution/international/parts/Asia-Pacific'
                ) ||
                enabledRouteContains(
                  '/distribution/international/parts/East-Asia'
                ) ||
                enabledRouteContains(
                  '/distribution/international/parts/Greater-Europe'
                ) ||
                enabledRouteContains(
                  '/distribution/international/parts/India'
                ) ||
                enabledRouteContains(
                  '/distribution/international/parts/Latin-America'
                )
              "
            >
              International
            </button>
            <div *ngIf="showInter">
              <button mat-flat-button class="{{
                  activeItem == 'all' ? 'exbtn-color' : 'exbtn'
                }} font-weight " *ngIf="
                  enabledRouteContains('/distribution/international/parts')
                " routerLink="distribution/international/parts" [queryParams]="{ filter: '' }">
                  Overall
                </button>

              <!-- <button
                mat-flat-button
                class="{{
                  activeItem == 'ame' ? 'exbtn-color' : 'exbtn'
                }} font-weight "
                (click)="setActiveItem('ame')"
                *ngIf="
                  enabledRouteContains('/distribution/international/parts/AME')
                "
              >
                AME
              </button> -->

              <div *ngIf="activeItem == 'ame'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/AME'
                    )
                  "
                  routerLink="distribution/international/parts/AME"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/AME'
                    )
                  "
                  routerLink="distribution/international/parts/AME"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/AME'
                    )
                  "
                  routerLink="distribution/international/parts/AME"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/AME'
                    )
                  "
                  routerLink="distribution/international/parts/AME"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>

              <!-- <button
                mat-flat-button
                class="{{
                  activeItem == 'arabia' ? 'exbtn-color' : 'exbtn'
                }} font-weight "
                (click)="setActiveItem('arabia')"
                *ngIf="
                  enabledRouteContains(
                    '/distribution/international/parts/Arabia-JV'
                  )
                "
              >
                Arabia JV
              </button> -->
              <div *ngIf="activeItem == 'arabia'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Arabia-JV'
                    )
                  "
                  routerLink="distribution/international/parts/Arabia-JV"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Arabia-JV'
                    )
                  "
                  routerLink="distribution/international/parts/Arabia-JV"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Arabia-JV'
                    )
                  "
                  routerLink="distribution/international/parts/Arabia-JV"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Arabia-JV'
                    )
                  "
                  routerLink="distribution/international/parts/Arabia-JV"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
              <!-- <button
                mat-flat-button
                class="{{
                  activeItem == 'asia' ? 'exbtn-color' : 'exbtn'
                }} font-weight "
                (click)="setActiveItem('asia')"
                *ngIf="
                  enabledRouteContains(
                    '/distribution/international/parts/Asia-Pacific'
                  )
                "
              >
                Asia Pacific
              </button> -->
              <div *ngIf="activeItem == 'asia'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Asia-Pacific'
                    )
                  "
                  routerLink="distribution/international/parts/Asia-Pacific"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Asia-Pacific'
                    )
                  "
                  routerLink="distribution/international/parts/Asia-Pacific"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Asia-Pacific'
                    )
                  "
                  routerLink="distribution/international/parts/Asia-Pacific"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Asia-Pacific'
                    )
                  "
                  routerLink="distribution/international/parts/Asia-Pacific"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
              <!-- <button
                mat-flat-button
                class="{{
                  activeItem == 'east' ? 'exbtn-color' : 'exbtn'
                }} font-weight "
                (click)="setActiveItem('east')"
                *ngIf="
                  enabledRouteContains(
                    '/distribution/international/parts/East-Asia'
                  )
                "
              >
                East Asia
              </button> -->
              <div *ngIf="activeItem == 'east'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/East-Asia'
                    )
                  "
                  routerLink="distribution/international/parts/East-Asia"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/East-Asia'
                    )
                  "
                  routerLink="distribution/international/parts/East-Asia"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/East-Asia'
                    )
                  "
                  routerLink="distribution/international/parts/East-Asia"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/East-Asia'
                    )
                  "
                  routerLink="distribution/international/parts/East-Asia"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
              <!-- <button
                mat-flat-button
                class="{{
                  activeItem == 'europe' ? 'exbtn-color' : 'exbtn'
                }} font-weight "
                (click)="setActiveItem('europe')"
                *ngIf="
                  enabledRouteContains(
                    '/distribution/international/parts/Greater-Europe'
                  )
                "
              >
                Greater Europe
              </button> -->
              <div *ngIf="activeItem == 'europe'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Greater-Europe'
                    )
                  "
                  routerLink="distribution/international/parts/Greater-Europe"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Greater-Europe'
                    )
                  "
                  routerLink="distribution/international/parts/Greater-Europe"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Greater-Europe'
                    )
                  "
                  routerLink="distribution/international/parts/Greater-Europe"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Greater-Europe'
                    )
                  "
                  routerLink="distribution/international/parts/Greater-Europe"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
              <!-- <button
                mat-flat-button
                class="{{
                  activeItem == 'india' ? 'exbtn-color' : 'exbtn'
                }} font-weight "
                (click)="setActiveItem('india')"
                *ngIf="
                  enabledRouteContains(
                    '/distribution/international/parts/India'
                  )
                "
              >
                India
              </button> -->
              <div *ngIf="activeItem == 'india'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/India'
                    )
                  "
                  routerLink="distribution/international/parts/India"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/India'
                    )
                  "
                  routerLink="distribution/international/parts/India"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/India'
                    )
                  "
                  routerLink="distribution/international/parts/India"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/India'
                    )
                  "
                  routerLink="distribution/international/parts/India"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
              <!-- <button
                mat-flat-button
                class="{{
                  activeItem == 'america' ? 'exbtn-color' : 'exbtn'
                }} font-weight "
                (click)="setActiveItem('america')"
                *ngIf="
                  enabledRouteContains(
                    '/distribution/international/parts/Latin-America'
                  )
                "
              >
                Latin America
              </button> -->
              <div *ngIf="activeItem == 'america'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Latin-America'
                    )
                  "
                  routerLink="distribution/international/parts/Latin-America"
                  [queryParams]="{ filter: '' }"
                >
                  Overall
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Latin-America'
                    )
                  "
                  routerLink="distribution/international/parts/Latin-America"
                  [queryParams]="{ filter: 'parts' }"
                >
                  Parts
                </button>
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Latin-America'
                    )
                  "
                  routerLink="distribution/international/parts/Latin-America"
                  [queryParams]="{ filter: 'service' }"
                >
                  Service
                </button>
                <button
                  disabled="true"
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="
                    enabledRouteContains(
                      '/distribution/international/parts/Latin-America'
                    )
                  "
                  routerLink="distribution/international/parts/Latin-America"
                  [queryParams]="{ filter: 'wholegoods' }"
                >
                  Wholegoods
                </button>
              </div>
            </div>
            <button
            mat-flat-button
            class="btn"
            routerLink="distribution/dbu_overall"
          >
            DBU Overall
          </button>
          </div>
        </div>
        <!-- International end -->
      </div>
    </div>
  </div>
  <!-- <div class="card" *ngIf="enabledRouteContains('/components/ctt/parts') 
    || enabledRouteContains('/cec-ctt-first-fit') ||
      enabledRouteContains('/ces-after-market') || 
      enabledRouteContains('/components/meritor')"
  > -->
  <div class="card" *ngIf="enabledRouteContains('/components/ctt/parts') 
    || enabledRouteContains('/cec-ctt-first-fit') ||
      enabledRouteContains('/ces-after-market') || 
      enabledRouteContains('/components/meritor') "
  >
    <div class="header">
      <p>
        <b>Components</b>
      </p>
      <div class="img-container">
        <img class="category-img" src="/assets/images/NRP.png" />
      </div>
      <div class="hide">
        <div class="btn-container">
          <div>
            <button
              mat-flat-button
              class="{{ activeItem == 'ces' ? 'btn-color' : 'btn' }}"
              (click)="setActiveItem('ces')" 
              title="Cummins Emission Solutions"
            >
               <abbr>CES</abbr> 
            </button>
            <div *ngIf="activeItem == 'ces'">
              <button mat-flat-button class="exbtn" *ngIf="enabledRouteContains('/ces-first-fit')"
                routerLink="ces-first-fit" disabled>
                First Fit
              </button>
              <button mat-flat-button class="exbtn" *ngIf="enabledRouteContains('/ces-after-market')"
                routerLink="ces-after-market">
                Aftermarket
              </button>
               <button mat-flat-button class="exbtn" *ngIf="enabledRouteContains('/')"
                routerLink="" disabled>
                OE & Aftermarket
              </button>
            </div>

            <!-- <button mat-flat-button
              routerLink="cummins-software-electronics" class="{{ activeItem == 'cse' ? 'btn-color' : 'btn' }}"
              (click)="setActiveItem('cse')"
              title="Cummins Software & Electronics"
              >
              <abbr>CSE</abbr>
            </button> -->

            <!-- <button mat-flat-button *ngIf="enabledRouteContains('/cummins-software-electronics')"
              routerLink="cummins-software-electronics" class="{{ activeItem == 'cse' ? 'btn-color' : 'btn' }}"
              (click)="setActiveItem('cse')" disabled
              title="Cummins Software & Electronics"
              >
              <abbr>CSE</abbr>
            </button> -->
            
            <button mat-flat-button *ngIf="enabledRouteContains('/components/meritor')" routerLink="components/meritor"
              class="{{ activeItem == 'meritor' ? 'btn-color' : 'btn' }}"
              title="Cummins Drivetrain and Braking Systems">
              <!-- <abbr>CDBS (Drivetrain and Braking Systems )</abbr> -->
                 CDBS
            </button>
            
            <button mat-flat-button class="{{ activeItem == 'cec' ? 'btn-color' : 'btn' }}"
              (click)="setActiveItem('cec')" title="Cummins Engine Components" *ngIf="false">
              <abbr>CEC</abbr>
            </button>
            
            <div *ngIf="activeItem == 'cec'">
              <button mat-flat-button class="exbtn" class="{{ expandItem == 'ctt' ? 'exbtn-color' : 'exbtn' }}"
                (click)="setExpandItem('ctt')" 
                title="Cummins Turbo Technologies">
                <abbr>CTT</abbr>
              </button>
              <div *ngIf="expandItem == 'ctt'">
                <button mat-flat-button class="exbtn subbtn" *ngIf="enabledRouteContains('/cec-ctt-first-fit')"
                  routerLink="cec-ctt-first-fit">
                  CTT ALL
                </button>

                <button mat-flat-button class="exbtn subbtn" *ngIf="enabledRouteContains('/components/ctt/parts')"
                  routerLink="components/ctt/parts">
                  Parts
                </button>

              </div>
            
              <button mat-flat-button class="exbtn" class="{{ expandItem == 'cfs' ? 'exbtn-color' : 'exbtn' }}"
                (click)="setExpandItem('cfs')" 
                title="Cummins Fuel Systems">
                <abbr>CFS</abbr>
              </button>
              <div *ngIf="expandItem == 'cfs'">
                <button mat-flat-button class="exbtn subbtn" *ngIf="enabledRouteContains('/cec-cfs-first-fit')"
                  routerLink="cec-cfs-first-fit" disabled>
                  First Fit
                </button>
              </div>
            
              <button mat-flat-button class="exbtn" *ngIf="enabledRouteContains('/jacobs-vehicle-systems')"
                routerLink="jacobs-vehicle-systems" class="{{ expandItem == 'jvs' ? 'exbtn-color' : 'exbtn' }}"
                (click)="setExpandItem('jvs')" title="Jacobs Vehicle Systems" disabled
                 >
                <abbr>JVS</abbr>
              </button>
            
            </div>

            <button
              mat-flat-button
              class="{{ activeItem == 'ccs' ? 'btn-color' : 'btn' }}"
              (click)="setActiveItem('ccs')"
              title="Cummins Components and Software"
            >
              CCS
            </button>

            <div *ngIf="activeItem == 'ccs'">
              <button mat-flat-button class="exbtn" (click)="setExpandItem('ccsTurbo')">
                 Turbochargers
              </button>
              <div *ngIf="expandItem == 'ccsTurbo'">
                <button mat-flat-button class="exbtn subbtn" *ngIf="enabledRouteContains('/cec-ctt-first-fit')"
                  routerLink="cec-ctt-first-fit">
                  ▪ OE &amp; Aftermarket
                </button>
                <button mat-flat-button class="exbtn subbtn" *ngIf="enabledRouteContains('/components/ctt/parts')"
                  routerLink="components/ctt/parts">
                  ▪ Aftermarket
                </button>
              </div>

              <button mat-flat-button class="exbtn" (click)="setExpandItem('ccsEngine')">
                 Engine Braking <br> &amp; ValveTrain Technologies
              </button>
              <div *ngIf="expandItem == 'ccsEngine'">
                <button mat-flat-button class="exbtn subbtn" routerLink="valvetrain">
                  ▪ OE &amp; Aftermarket
                </button>
              </div>

              <button mat-flat-button class="exbtn" (click)="setExpandItem('ccsSoftware')">
                 Software and Electronics
              </button>
              <div *ngIf="expandItem == 'ccsSoftware'">
                <button mat-flat-button class="exbtn subbtn" routerLink="software-electronics">
                  ▪ OE &amp; Aftermarket
                </button>
              </div>

              <button mat-flat-button class="exbtn" (click)="setExpandItem('ccsFuel')">
                 Fuel Systems
              </button>
              <div *ngIf="expandItem == 'ccsFuel'">
                <button mat-flat-button class="exbtn subbtn" routerLink="fuel-systems">
                  ▪ OE &amp; Aftermarket
                </button>
              </div>
            </div>

                <!-- ------------------- -->
            <!-- <button
              mat-flat-button
              class="{{ activeItem == 'cefs' ? 'btn-color' : 'btn' }}"
              (click)="setActiveItem('cefs')"
            >
              CEFS
            </button> -->
            <div *ngIf="activeItem == 'cefs'">
              <button mat-flat-button class="exbtn" disabled="true">
                First Fit
              </button>
            </div>
            <!-- <button
              mat-flat-button
              class="{{ activeItem == 'ctt' ? 'btn-color' : 'btn' }}"
              (click)="setActiveItem('ctt')"
            >
              CTT
            </button> -->
            <div *ngIf="activeItem == 'ctt'">
              <button disabled="true" mat-flat-button class="exbtn">
                First Fit
              </button>
              <button
                mat-flat-button
                class="exbtn"
                class="{{ expandItem == 'cttparts' ? 'exbtn-color' : 'exbtn' }}"
                (click)="setExpandItem('cttparts')"
              >
                Parts
              </button>
              <div *ngIf="expandItem == 'cttparts'">
                <button
                  mat-flat-button
                  class="exbtn subbtn"
                  *ngIf="enabledRouteContains('/components/ctt/parts')"
                  routerLink="components/ctt/parts"
                >
                  Sales/Margin Realization
                </button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="card"
    *ngIf="
      enabledRouteContains('/power-systems/engines/sales-realization') ||
      enabledRouteContains('/power-systems/power-gen/sales-realization') ||
      enabledRouteContains('/power-systems/parts/psbu') || 
      enabledRouteContains('/power-systems/margin-realization')
    "
  >
    <div class="header">
      <p>
        <b>Power Systems</b>
      </p>
      <div class="img-container">
        <img class="category-img" src="/assets/images/PowerGen.png" />
      </div>
      <div class="hide">
        <div class="btn-container">
          <div>
            <button
              mat-flat-button
              class="{{
                activeItem == 'powerSystmEngine' ? 'btn-color' : 'btn'
              }}"
              (click)="setActiveItem('powerSystmEngine')"
              *ngIf="
                enabledRouteContains('/power-systems/engines/sales-realization')
              "
            >
              Engines
            </button>
            <div *ngIf="activeItem == 'powerSystmEngine'">
              <button
                mat-flat-button
                class="exbtn"
                *ngIf="
                  enabledRouteContains(
                    '/power-systems/engines/sales-realization'
                  )
                "
                routerLink="power-systems/engines/sales-realization"
              >
                Sales Realization
              </button>

              <!-- <button mat-flat-button class="exbtn" *ngIf="enabledRouteContains('/price-realization')"
                routerLink="price-realization" disabled>
                Price Realization
              </button> -->

              <button mat-flat-button class="exbtn" 
              *ngIf="enabledRouteContains('/power-systems/margin-realization')"
                routerLink="power-systems/margin-realization">
                Margin Realization
              </button>
            </div>
            <button
              mat-flat-button
              class="{{
                activeItem == 'powerSystmPowerGen' ? 'btn-color' : 'btn'
              }}"
              (click)="setActiveItem('powerSystmPowerGen')"
              *ngIf="
                enabledRouteContains(
                  '/power-systems/power-gen/sales-realization'
                )
              "
            >
              Power Gen
            </button>
            <div *ngIf="activeItem == 'powerSystmPowerGen'">
              <button
                mat-flat-button
                class="exbtn"
                *ngIf="
                  enabledRouteContains(
                    '/power-systems/power-gen/sales-realization'
                  )
                "
                routerLink="power-systems/power-gen/sales-realization"
                [disabled]="true"
              >
                Sales Realization
              </button>
            </div>
            <button
              mat-flat-button
              class="{{
                activeItem == 'powerSystmParts' ? 'btn-color' : 'btn'
              }}"
              (click)="setActiveItem('powerSystmParts')"
              *ngIf="enabledRouteContains('/power-systems/parts/psbu')"
            >
              Parts
            </button>
            <div *ngIf="activeItem == 'powerSystmParts'" class="vertical-group">
              <div>
                <button
                  mat-flat-button
                  class="exbtn"
                  *ngIf="enabledRouteContains('/power-systems/parts/psbu')"
                  routerLink="power-systems/parts/psbu"
                >
                  Sales Realization
                </button>
              </div>
              <div>
                <button
                  mat-flat-button
                  class="exbtn subbtn split-button"
                  *ngIf="enabledRouteContains('/power-systems/parts/psbu')"
                  type="button"
                  (click)="goToSegmentationDashboard()"
                >
                  <span class="split-line">Aft. Segmentation</span>
                  <span class="split-line">Dashboard</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" *ngIf="enabledRoutes.length === 0">
    <div class="header">
      <p>
        <b>Accelera</b>
      </p>
      <div class="img-container">
        <img class="category-img" src="/assets/images/newpower.png" />
      </div>
    </div>
  </div>
  <div class="card" *ngIf="enabledRouteContains('/overall/overall-view')">
    <div class="header">
      <p><b>Overall</b></p>
      <div class="img-container">
        <img class="category-img" src="/assets/images/Dashboard.png" />
      </div>
      <div class="hide">
        <div class="btn-container">
          <div>
            <button
              class="btn"
              mat-flat-button
              *ngIf="enabledRouteContains('/overall/overall-view')"
              routerLink="/overall/overall-view"
            >
              Overall View
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" *ngIf="enabledRouteContains('/omni/dashboard')">
    <div class="header">
      <p><b>Omni</b></p>
      <div class="img-container">
        <img class="category-img" src="/assets/images/omni.png" />
      </div>
      <div class="hide">
        <div class="btn-container">
          <div>
            <button
              class="btn"
              mat-flat-button
              *ngIf="enabledRouteContains('/omni/dashboard')"
              routerLink="omni/dashboard"
            >
              Omni Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
